export default {
  computed: {
    user() {
      return this.$store.state.user;
    },
    products() {
      return this.$store.state.shop.products;
    },
  },
  methods: {
    getProduct(id) {
      this.$router.push(`/shop-product/${id}`);
    },
  },
  created() {
    this.$store.dispatch('shop/GetProducts', this.user.profile_id);
  },
};
